<template>
  <div style="height:250px; width: 235px">
    <q-input v-model="loginData.email" type="email" label="Email" class="q-pa-sm" outlined :error="loginError" ref="emailInput"/>
    <q-input v-model="loginData.password" type="password" label="Password" class="q-pa-sm" outlined bottom-slots :error-message="loginErrorMessage" :error="loginError" @keyup.enter="login"/>
    <div style="text-align:center;padding-top:10px"><a :href="`/#/forgot-password`">Forgot your password?</a></div>
    <q-btn color="primary" @click="login" class="full-width" style="margin-top: 10px">Login</q-btn>
  </div>
</template>

<script>
import store from '../store'

export default {
  name: 'LoginOpen',
  props:{
    value: {
        registrationDetails: Object,
        shippingDetails: Object,
        cartId: String
    }
  },
  data () {
    return {
      loginData: {
        email: '',
        password: ''
      },
      loginError: false,
      loginErrorMessage: ''
    }
  },
  methods: {
    reset () {
      this.loginData.email = ''
      this.loginData.password = ''
      this.loginError = false
    },
    async login () {
      if (this.loginData.email && this.loginData.password) {
        try {
        this.loginData.cartID = this.value.cartId;
        await store.dispatch('auth/login', this.loginData)
        await store.dispatch('cart/init');
        await store.dispatch('filters/fetchProductColours')
          this.reset()
          // eslint-disable-next-line no-undef
          analytics.track('Login')
        this.value.shippingDetails = { ...store.getters['auth/getAccountAddress'] }
        } catch (err) {
          if (err.networkError) {
            this.loginErrorMessage = 'Could not contact server'
          } else if (err.graphQLErrors && err.graphQLErrors.length) {
            this.loginErrorMessage = err.graphQLErrors[0].message
          } else {
            this.loginErrorMessage = 'Error'
          }
          this.loginError = true
        }
      } else {
        this.loginError = true
        this.loginErrorMessage = 'Incorrect username or password'
      }
    }
  },
  created () {
    this.$nextTick(() => {
      this.$refs.emailInput.focus()
    //   this.reset()
    })
  }
}
</script>
